import React, { Component } from 'react';
import { element, number, object, string } from 'prop-types';

class Column extends Component {
  static propTypes = {
    children: element,
    flex: number,
    style: object,
    className: string
  };

  static defaultProps = {
    flex: 1,
    style: {},
    className: ''
  };

  render() {
    return (
      <div
        className={this.props.className}
        style={{
          ...this.props.style,
          flexGrow: this.props.flex,
          height: '100vh',
          transition: 'flex-grow 200ms ease-out'
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Column;
